import React, { useEffect, useState } from "react";
import AOS from "aos";
import { useLocation, useParams } from "react-router-dom";
import liaison_pdf from '../../images/brochures/liaison_brochure.pdf'
import Button from "../../Components/Button";

// commerical images
import commerical_img from '../../images/Industries/micro-landing/commerical_images/commerical_category.png';
import landsandlands_brochure from "../../images/brochures/L&L_brochure.pdf";

function IndsutryDescription() {



    const params = useParams();
    const path = params.micro_id;


    let [show, setShow] = useState(false);

    useEffect(() => {
        if (path === "retail" || path === "development" || path === "commercial") {
            setShow(true);
        }
        else {
            setShow(false);
        }
    }, [])


    const data = {
        it: {
            heading: "Properties backed by data",
            content: "Our Data-driven approah provides a comprehensive suite of property solutions specializing in the acquisition, rental and leasing of land, along with Plug and Play Building solutions, specifically tailored to cater the unqiure infrastructure requirements of IT companies."
        },
        health: {
            heading: "Retail Services",
            content: "Your outlet’s success starts with the right site. We help tenants secure spaces that maximise visibility, attract footfall, and drive returns — backed by organised inventory and data-driven insights.",
        },
        development: {
            heading: "Location Anchoring for Developers",
            content: "Every successful project starts with the right micromarket. With data-driven insights, we help you secure breakthrough sites, optimise land use, and shape the right product mix. From layouts and approvals to marketing strategy, we partner end-to-end to maximise success.",
        },
        logistics: {
            heading: "Logistics & Warehousing ",
            content: "Factory sites, warehouses, logistics parks — the right location fuels efficiency and lowers costs. We deliver land acquisition, site selection, build-to-suit solutions, and leasing under one roof. With expertise in industrial corridors and supply-chain hubs, every move is compliant, customised, and aligned with your business goals.",
        },
        energy: {
            heading: "Energy",
            content: "We help investors and developers identify, assemble, and secure large tracts of land tailored for utility-scale solar farms and wind projects.",
        },
        manufacturing: {
            heading: "Manufacturing",
            content: "Laboris et quis reprehenderit pariatur occaecat excepteur officia velit laboris minim enim commodo dolor velit. Id voluptate velit in enim. Dolore exercitation veniam ex deserunt. Occaecat cillum id tempor Lorem. Adipisicing anim cupidatat ex proident amet occaecat dolore sit fugiat non."
        },
        hospitality: {
            heading: "Hospitality Industry",
            content: "Laboris et quis reprehenderit pariatur occaecat excepteur officia velit laboris minim enim commodo dolor velit. Id voluptate velit in enim. Dolore exercitation veniam ex deserunt. Occaecat cillum id tempor Lorem. Adipisicing anim cupidatat ex proident amet occaecat dolore sit fugiat non."
        },
        retail: {
            heading: "Retail Location Services",
            content: "Your outlet’s success starts with the right site. We help tenants secure spaces that maximise visibility, attract footfall, and drive returns — backed by organised inventory and data-driven insights."
        },
        commercial: {
            heading: "Thriving work destinations, lively neighbourhoods",
            content: "Find new communities that are inclusive with innovative workplaces, equitable homes, premium apartments, and social and civic amenities to create an experience that is unique and specific to your needs."
        },


    };

    const retail_stat = [
        {
            milestone_number: "100+",
            milestone_content: "Corporate clients handle",
        },
        {
            milestone_number: "200 units",
            milestone_content: "Rented out",
        },
        {
            milestone_number: "500+",
            milestone_content: "Properties and Facilities",
        }
    ]

    const development_stat = [
        {
            milestone_number: "80+ Crores",
            milestone_content: "Total Transaction Value",
        },
        {
            milestone_number: "15,900",
            milestone_content: "Leasing and Sale Transactions",
        },
        {
            milestone_number: "500+",
            milestone_content: "Properties and Facilities",
        }
    ]

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);


    return (
        <div className="max-w-full mx-auto mt-20 mb-9 px-5 lg:px-0">

            <div className="max-w-[822px] mx-auto my-[30px] md:my-[90px]">
                <h1 className={"font-noto text-[#17212B] text-[38px] sm:text-[45px] font-bold text-center mx-auto" + data[path].heading_classname} data-aos="fade-up">{data[path].heading}</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
                <p className="service-description max-w-[822px] mx-auto" data-aos="fade-up" data-aos-duration="1100">{data[path].content} </p>
            </div>


            {/* Number count - Retail */}

            <section className={show === true && path === "retail" ? "bg-[#363537] text-white font-alibaba my-[130px] px-4 py-[40px] md:pt-[130px] md:pb-[80px]" : "hidden"} data-aos="fade-up">

                <div className="max-w-[910px] mx-auto px-2 sm:flex flex-wrap justify-between sm:px-8 lg:px-0">
                    {
                        retail_stat.map((items) => {
                            return (
                                <div className="w-[232px] mx-auto text-center mt-20 sm:mt-6 lg:mt-0 md:mx-0" >
                                    <h2 className="text-yellow text-[40px] font-bold leading-[45px] max-w-[236px]"data-aos="fade-up">{items.milestone_number}</h2>
                                    <hr className="w-full border-[0.50px] border-[#EECA01] my-[25px]" data-aos="fade-up"/>
                                    <h3 className="text-[20px]" data-aos="fade-up">{items.milestone_content}</h3>
                                </div>

                            );
                        })}
                </div>

                <div className='flex justify-center mt-[100px] mb-[20px]'data-aos="fade-up">
                    <Button
                        name={"Download Brochure"}
                        design={"filled"}
                        action={"download"}
                        section_id={landsandlands_brochure}
                    />
                </div>

            </section>


            {/*Number count - Development */}

            <section className={show === true && path === "development" ? "bg-[#363537] text-white font-alibaba my-[130px] px-4 py-[40px] md:pt-[130px] md:pb-[80px]" : "hidden"} data-aos="fade-up">

                <div className="max-w-[910px] mx-auto px-2 sm:flex flex-wrap justify-between px-8 lg:px-0" >
                    {
                        development_stat.map((items) => {
                            return (
                                <div className="w-[232px] mx-auto text-center mt-20 sm:mt-6 lg:mt-0 md:mx-0">
                                    <h2 className="text-yellow text-[40px] font-bold leading-[45px] max-w-[236px]" data-aos="fade-up">{items.milestone_number}</h2>
                                    <hr className="w-full border-[0.50px] border-[#EECA01] my-[25px]"  data-aos="fade-up"/>
                                    <h3 className="text-[20px]" data-aos="fade-up">{items.milestone_content}</h3>
                                </div>

                            );
                        })}
                </div>

                <div className='flex justify-center mt-[100px] mb-[20px]'>
                   <Button
                        name={"Download Brochure"}
                        design={"filled"}
                        action={"download"}
                        section_id={landsandlands_brochure}
                    />
                </div>

            </section>

            {/* commercial  */}

            <section className={show === true && path === 'commercial' ? "bg-grey px-6 py-[80px] sm:py-[120px]" : "hidden"} data-aos="fade-up">
                <img className="w-fit xl:w-[950px] lg:h-[1370px] mx-auto object-fit" src={commerical_img} alt="commerical catergory" />
            </section>


            {/* Number count - Retail */}
            {/* <div className={show === true && path === "retail" ? "flex flex-col items-center sm:flex-row mt-16 gap-x-7 justify-center w-full": "hidden"}>
                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">100+</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Corporate Client Handles</p>
                    </div>
                    
                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">200000</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Rented out</p>
                    </div>

                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">500+</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Properties and Facilities</p>
                    </div>
                </div>  */}

            {/* Number count - development */}
            {/* <div className={show === true && path === "development" ? "flex flex-col items-center sm:flex-row mt-16 gap-x-7 justify-center w-full": "hidden"}>
                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">81.3</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Total Transaction Value</p>
                    </div>
                    
                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">15,900</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Leasing and Sale Transactions</p>
                    </div>

                    <div className="sm:w-1/4 w-full border-t-2 border-[#CAD1D3] py-7 sm:py-5">
                        <p className="font-[Lato] text-[58px] text-[Worksans] text-[#1D1D1F] font-medium leading-[58px] ">500+</p>
                        <p className="font-[merriweather] text-[#757575] text-[20px] font-normal leading-[22.3px] mt-5">Properties and Facilities</p>
                    </div>
                </div> */}


        </div>



    )
}


export default IndsutryDescription